import React, { useState } from 'react';
import { DIAGNOSTIC_ROLES } from '@onboarding-dashboard/shared';
import { useAuth } from '../../contexts/AuthContext.js';
import { DiagnosticPanel } from './DiagnosticPanel.js';
import './version-badge.css';

export function VersionBadge(): React.ReactElement {
  const [showDiagnostics, setShowDiagnostics] = useState(false);
  const { hasRole, user } = useAuth();

  const canAccessDiagnostics = (DIAGNOSTIC_ROLES ?? []).some((r) => hasRole(r));

  const handleDoubleClick = (): void => {
    if (canAccessDiagnostics) {
      setShowDiagnostics(true);
    }
  };

  return (
    <>
      <span className="version-badge" onDoubleClick={handleDoubleClick}>
        v{__APP_VERSION__}
      </span>
      <DiagnosticPanel
        isOpen={showDiagnostics}
        onClose={() => setShowDiagnostics(false)}
        userEmail={user?.email ?? ''}
      />
    </>
  );
}
